import { API_INSTANCE, fullBuildURL } from 'src/features/utils';
import { API_URL } from 'src/utils/transport';

export const fetchSelectedSiteApi = async () => {
  return await fetch(`${API_URL}/api/v1/accounts/select-site`, {
    method: 'POST',
    redirect: 'manual',
    credentials: 'include',
  });
};

export const fetchSideByIdApi = async (siteId: string) => {
  return await API_INSTANCE.get(fullBuildURL(`/api/v1/dashboard/sites/${siteId}`));
};

export const updateSiteDataApi = async (siteId: string, siteData: any) => {
  return await API_INSTANCE.put(`/api/v1/dashboard/sites/${siteId}`, siteData);
};
